<template>
    <div id="EDSCriteria">
      <v-client-table ref="table" :columns="columns" :data="TblData" :options="options"  v-if="TblData.length">  
        <div slot="beforeTable"  class="form-group row VueTables_Adduser Maintitle mr-1 ml-1"> 
          <div class="col-4 float-left mt-1 pl-1">
            <strong>EDS Drugs Criteria:</strong>
          </div> 

        </div>
        <span class="pointer" v-on:click="showMsgBox('Are you sure you want to delete this Criteria?',props.row,1,null)" slot="delete" slot-scope="props" ><i class="far fa-trash-alt"></i></span>
    </v-client-table>
    <div class="row thing my-0 p-0 m-1">
        <div class="col-8"> 
          <div class="form-group row   my-0">
            <label for="roles" class="col-sm-4 col-form-label col-form-label-sm">Do you want to add OTHER Criteria ?</label>
            <div class="col-sm-8">
              
              <span class="form-control form-control-sm" style="border-style: hidden;">
                <toggle-button   class=""  v-model="otherCriteria" :switch-color="{
                    checked: '#25EF02',
                    unchecked: 'linear-gradient(red, yellow)',
                  }" :value="false" color="#82C7EB" :sync="true" :labels="{ checked: 'YES', unchecked: 'NO' }" /> 
              </span>
          
 
            </div>  
          </div>
  
        </div>
      </div>


     <form v-if="otherCriteria == false" class="card  p-3 mb-1" id="SearchForm">

      <div class="form-group row  my-0"> 
      <div class="card-header d-flex align-items-center  pl-1 col-sm-8" style="height: 1rem; text-align:left;">
            <h5><small class="text-muted"><b>Enter EDS Criteria/Diagnosis and Coverage:</b></small></h5>
      </div>
      <div class="col-sm-4 my-0">
        <div class="card-header d-flex align-items-center  pl-1" style="height: 1rem; text-align:left;">
      <h5><small class="text-muted"><b>EDS MAX Coverage:</b></small></h5></div>
      </div> 
    </div>


      
      <div class="form-group row  my-1">
        <div class="col-8"> 
          <div class="form-group row  my-0">
            <label for="roles" class="col-sm-4 col-form-label col-form-label-sm">Status:</label>
            <div class="col-sm-8">
              <template class="p-0 m-0 no-gutters">
                <RadioToggleButtons v-model="status" :values="AttachValues" color="#006537" textColor="#000"
                  selectedTextColor="#fff" />
              </template>
              <div calss="my-0"   v-show="$v.status.$error" :class="{ 'my-0': $v.status.$error}"  >
                  <small class="sml-red" v-if="!$v.status.required && otherCriteria == false">This field is required.</small>  
               </div>
            </div>  
          </div>
  
        </div>
        <div class="col-4">
          <div class="form-group row my-0">
            <label for="MinAge" class="col-sm-4 label-small my-0">Min Age:</label>
            <div class="col-sm-4 my-0">
              <input type="text>" maxlength="2" v-model="Minage" class="form-control form-control-sm" >
              <div calss="my-0"   v-show="$v.Minage.$error" :class="{ 'my-0': $v.Minage.$error}"  > 
               <small class="sml-red" v-if="!$v.Minage.required && otherCriteria == false">This field is required.</small>
               <small class="sml-red" v-if="!$v.Minage.numeric && otherCriteria == false">must be a number.</small> 
              </div> 
            </div>

          </div>
        </div>
      </div>
      <div class="form-group row  my-1">
        <div class="col-8">
          <div class="form-group row my-0">
            <label for="diag" class="col-sm-4 label-small my-0">Diagnosis:</label>
            <div class="col-sm-8 my-0">
              <textarea wrap="on" rows="2" max="65" id="diag" type="textarea" maxlength="65" v-model="Diagnosis"  placeholder="Add Diagnosis"
              class="my-0 form-control text-area-xs"
            ></textarea>
            <span v-if="Diagnosis.length"> {{ Diagnosis.length }}/65</span>
            <div calss="my-0"   v-show="$v.Diagnosis.$error" :class="{ 'my-0': $v.Diagnosis.$error}"  >
              
              <small class="sml-red" v-if="!$v.Diagnosis.required">This field is required.</small>
              <small class="sml-red" v-if="!$v.Diagnosis.maxlength">Diagnosis length is invalid must be < 66</small>
            
            </div> 
          </div>
      
        </div>
        </div>
        <div class="col-4">
          <div class="form-group row my-0">
            <label for="EffectiveDate" class="col-sm-4 label-small my-0">Max Age:</label>
            <div class="col-sm-4 my-0">
              <input type="text>" maxlength="3" v-model="Maxage" class="form-control form-control-sm" >
              <div calss="my-0"   v-show="$v.Maxage.$error" :class="{ 'my-0': $v.Maxage.$error}" > 
              <small class="sml-red" v-if="!$v.Maxage.required">This field is required.</small>
              <small class="sml-red" v-if="!$v.Maxage.numeric">must be a number.</small>
              <!-- <small class="sml-red" v-if="!$v.Maxage.maxlength">Max Age length is invalid</small> -->
            
          </div> 
            </div>

        </div>          
        </div>
      </div>    

      <div class="form-group row  my-1">
        <div class="col-8">
          <div class="form-group row my-0">
            <label for="EffectiveDate" class="col-sm-4 label-small my-0">Criteria:</label>
            <div class="col-sm-8 my-0">
              <textarea wrap="on" rows="12" max="2500" id="Comments" maxlength="2500" type="textarea" v-model="criteria"  placeholder="Add Criteria"
              class="my-0 form-control text-area-xs"
            ></textarea>
            <span v-if="criteria.length"> {{ criteria.length }}/2500</span>
            <div calss="my-0"   v-show="$v.criteria.$error" :class="{ 'my-0': $v.criteria.$error}"  >
              
              <small class="sml-red" v-if="!$v.criteria.required">This field is required.</small>
              <small class="sml-red" v-if="!$v.criteria.maxlength">Criteria length is invalid </small>
            
          </div> 
            </div>

        </div>
        </div>
        <div class="col-4 float-left" ><h5><small class="text-muted card-header d-flex align-items-center " style="height: 1rem; text-align:left;"><b>EDS MAX Duration:</b></small></h5>
          <div class="form-group row my-0">
            
            <label class="col-sm-4 label-small my-0">Open Ended Expiry:</label>
            <div class="col-sm-4 my-0" >
              <span class="form-control form-control-sm" style="border-style: hidden;">
                <toggle-button    class=""  v-model="isOpenEnded" :switch-color="{
                    checked: '#25EF02',
                    unchecked: 'linear-gradient(red, yellow)',
                  }" :value="false" color="#82C7EB" :sync="true" :labels="{ checked: 'YES', unchecked: 'NO' }" /> 
              </span>
                <!-- <select   id="Units" v-model="Unit" class="form-control form-control-sm">
                  <option v-for="option in backdatingunits" v-bind:value="option.id" :key="option.id">
                    {{ option.text }}
                  </option>
                </select> -->
                <!-- <div calss="my-0"   v-show="$v.Unit.$error" :class="{ 'my-0': $v.Unit.$error}"  >
               
               <small class="sml-red" v-if="!$v.Unit.required">This field is required.</small>
              
           </div>  -->
            </div>
  
          </div> 
          
          <div class="form-group row my-2" >
            
            <label class="col-sm-4 label-small my-0">Unit:</label>
            <div class="col-sm-4 my-0" >
                <select   id="Units" v-model="Unit" class="form-control form-control-sm" :Disabled="isOpenEnded==true" v-if="isOpenEnded == false">
                  <option v-for="option in backdatingunits" v-bind:value="option.id" :key="option.id">
                    {{ option.text }}
                  </option>
                </select>
                <input maxlength="0" v-model="UnitisOpenEnded"  class="form-control form-control-sm"  :Disabled="isOpenEnded==true" v-if="isOpenEnded == true">
            <div calss="my-0"   v-show="$v.Unit.$error" :class="{ 'my-0': $v.Unit.$error}"  >
               
               <!-- <small class="sml-red" v-if="!$v.Unit.required">This field is required.</small> -->
               <small class="sml-red" v-if="!$v.Unit.required">This field is required.</small>
              
           </div>
            </div>
  
          </div>  
          
          
          <div class="form-group row my-0" >
            <label for="EffectiveDate" class="col-sm-4 label-small my-0">Length:</label>
            <div class="col-sm-4 my-0">
              <input type="number>" maxlength="2" v-model="Length"  class="form-control form-control-sm"  :Disabled="isOpenEnded==true" v-if="isOpenEnded == false">
              <input type="number>" maxlength="2" v-model="LengthisOpenEnded"  class="form-control form-control-sm"  :Disabled="isOpenEnded==true" v-if="isOpenEnded == true">
              <div calss="my-0"   v-show="$v.Length.$error" :class="{ 'my-0': $v.Length.$error}"  >
               
                <small class="sml-red" v-if="!$v.Length.required">This field is required.</small><br>
               <!-- <small class="sml-red" v-if="(!$v.Length.numeric && otherCriteria == false && isOpenEnded == true)">must be a number.</small> -->
               <small class="sml-red" v-if="!$v.Length.numeric">must be a number.</small>
               <!-- <small class="sml-red" v-if="!$v.Length.maxlength">Length is invalid </small> -->
             
           </div> 
            </div>

        </div>          


        </div>
        <!-- <div class="col-4  my-0">
          <div class="form-group row">
               <div class="col-sm-8 card-header d-flex align-items-center  pl-1" style="height: 1rem; text-align:left;">
            <h5><small class="text-muted"><b>EDS MAX Duration:</b></small></h5>
          </div> 
          </div>
        </div>  -->

      </div>

      <div class="form-group row  my-1">
        <div class="col-8">
          <!-- <div class="form-group row my-0">
            <label for="EffectiveDate" class="col-sm-4 label-small my-0">Criteria:</label>
            <div class="col-sm-8 my-0">
              <textarea wrap="on" rows="3" max="2500" id="Comments" maxlength="2500" type="textarea" v-model="criteria"  placeholder="Add Criteria"
              class="my-0 form-control text-area-xs"
            ></textarea>
            <span v-if="criteria.length"> {{ criteria.length }}/2500</span>
            <div calss="my-0"   v-show="$v.criteria.$error" :class="{ 'my-0': $v.criteria.$error}"  >
              
              <small class="sml-red" v-if="!$v.criteria.required">This field is required.</small>
              <small class="sml-red" v-if="!$v.criteria.maxlength">Criteria length is invalid </small>
            
             </div> 
            </div>

        </div> -->
        </div>
        <div class="col-4 float-left" >
          <!-- <h5><small class="text-muted card-header d-flex align-items-center " style="height: 1rem; text-align:left;"><b>EDS MAX Duration:</b></small></h5> -->
          <!-- <div class="form-group row my-0">
            
            <label class="col-sm-4 label-small my-0">Unit:</label>
            <div class="col-sm-4 my-0" >
                <select   id="Units" v-model="Unit" class="form-control form-control-sm">
                  <option v-for="option in backdatingunits" v-bind:value="option.id" :key="option.id">
                    {{ option.text }}
                  </option>
                </select>
                <div calss="my-0"   v-show="$v.Unit.$error" :class="{ 'my-0': $v.Unit.$error}"  >
               
               <small class="sml-red" v-if="!$v.Unit.required">This field is required.</small>
              
           </div> 
            </div>
  
          </div>   -->
          
          
          <!-- <div class="form-group row my-0">
            <label for="EffectiveDate" class="col-sm-4 label-small my-0">Length:</label>
            <div class="col-sm-4 my-0">
              <input type="number>" maxlength="2" v-model="Length"  class="form-control form-control-sm" >
              <div calss="my-0"   v-show="$v.Length.$error" :class="{ 'my-0': $v.Length.$error}"  >
               
               <small class="sml-red" v-if="!$v.Length.required">This field is required.</small>
               <small class="sml-red" v-if="!$v.Length.numeric">must be a number.</small>
           
             
           </div> 
            </div>

        </div> -->


        </div>
      </div>      

      <div class="form-group row  my-1">
        <div class="col-8">
          <div class="form-group row my-0">
            <label for="EffectiveDate" class="col-sm-4 label-small my-0">Generate Letter:</label>
            <div class="col-sm-4 my-0">
              <span class="form-control form-control-sm" style="border-style: hidden;">
                <toggle-button   class=""  v-model="GenLetterAllow" :switch-color="{
                    checked: '#25EF02',
                    unchecked: 'linear-gradient(red, yellow)',
                  }" :value="false" color="#82C7EB" :sync="true" :labels="{ checked: 'YES', unchecked: 'NO' }" /> 
              </span>
            </div>
            <!-- <div  class="col-sm-4" v-show="$v.effectivedate.$error">
                <div class="row">
                    <small class="sml-red" v-if="!$v.effectivedate.required">Effective date is required</small>
                </div>
            </div> -->
        </div> 
        </div>
     
        <div class="col-4" >

          <div class="form-group row my-0">
            <label for="EffectiveDate" class="col-sm-4 label-small my-0">Expiry Date Editable:</label>
            <div class="col-sm-4 my-0">
              <span class="form-control form-control-sm" style="border-style: hidden;">
                <toggle-button   class=""  v-model="ExpChangeAllow" :switch-color="{
                    checked: '#25EF02',
                    unchecked: 'linear-gradient(red, yellow)',
                  }" :value="false" color="#82C7EB" :sync="true" :labels="{ checked: 'YES', unchecked: 'NO' }" /> 
              </span>
            </div>
   
        </div> 

          <!-- <div class="form-group row my-0">
            <label for="EffectiveDate" class="col-sm-4 label-small my-0">Length:</label>
            <div class="col-sm-4 my-0">
              <input type="number>" maxlength="2" v-model="Length"  class="form-control form-control-sm" >
              <div calss="my-0"   v-show="$v.Length.$error" :class="{ 'my-0': $v.Length.$error}"  >
               
               <small class="sml-red" v-if="!$v.Length.required">This field is required.</small>
               <small class="sml-red" v-if="!$v.Length.numeric">must be a number.</small>
           
               </div> 
            </div> 
          </div> -->
        </div>

        <!-- <div class="col-4" v-if="ExpChangeAllow== true"> -->
      
        
      

  
      </div>

      <div class="form-group row  my-0">
        <div class="col-8">
          <div class="form-group row  my-0">
            <label for="roles" class="col-sm-4 col-form-label col-form-label-sm">Comments Allowed:</label>
            <div class="col-sm-8">
              <template class="p-0 m-0 no-gutters">
                <RadioToggleButtons  v-model="CommentsAllow" :values="CommentsValues" color="#006537" textColor="#000"
                  selectedTextColor="#fff" />
              </template>
              <div calss="my-0"   v-show="$v.CommentsAllow.$error" :class="{ 'my-0': $v.CommentsAllow.$error}"  >
                  
                  <small class="sml-red" v-if="!$v.CommentsAllow.required && otherCriteria == false">This field is required.</small>
                
               </div>
              </div>

        </div>
        </div>

           <div class="col-4">
          <!-- <div class="form-group row my-0">
            <label for="EffectiveDate" class="col-sm-4 label-small my-0">Expiry Date Editable:</label>
            <div class="col-sm-4 my-0">
              <span class="form-control form-control-sm" style="border-style: hidden;">
                <toggle-button   class=""  v-model="ExpChangeAllow" :switch-color="{
                    checked: '#25EF02',
                    unchecked: 'linear-gradient(red, yellow)',
                  }" :value="false" color="#82C7EB" :sync="true" :labels="{ checked: 'YES', unchecked: 'NO' }" /> 
              </span>
            </div>
   
        </div>  -->
        </div>

        <!-- <div class="col-4" v-if="ExpChangeAllow== true"> -->



    
      </div>
      
    </form> 
    <hr>
    <div class="row  p-2">
        
        <div class="col-sm-2">
          <button v-on:click="SavePopup" type="button" class="btn BtnSave btn-sml"><i :class="saveIcon"></i>{{saveBtnName}}</button>
          <!-- <button type="button" v-on:click="AddCriteria" class="btn btn-primary form-control" >Submit</button> -->
          </div>           
          <div class="col-sm-4">
             
          </div>
          <div class="col-sm-2">
            <button type="button" v-on:click="ClosePopup()" class="btn btn-primary form-control" >Close</button>
          </div>
      </div>
    <div class="form-group row  my-0">
      <div class="col-6"></div>
      <div class="col-6"></div>
    </div>

    </div>
    </template> 
    
    <script>
    import Vue from 'vue'; 
    import {mapGetters} from 'vuex'
    import moment from 'moment'
    import axios from 'axios' 
    import Datepicker from 'vuejs-datepicker';
    import LayoutDefault from '@/Common/Default/DefaultLayout.vue'; 
    import Subtitle from '@/Common/Default/SubTitle.vue'; 
    import Card from "@/Common/Card.vue";
    import CardBody from "@/Common/CardBody.vue";
    import TileNote from "@/Common/TileNote.vue";
    import { PopUpVariant } from '@/Common/Default/PopUpVariant';
    import { request } from 'http';
    import PatientHistoryDetail from '@/components/Common/PatientHistoryDetail.vue'
    import Vuelidate from 'vuelidate'
    import {helpers, required, requiredIf,minLength, sameAs, not, maxLength, numeric, integer, between} from 'vuelidate/lib/validators'
    
    Vue.use(Vuelidate);
    
    export default  {
      props: {
         // TblData: '',
          mode: '',
          Type: '1' ,
          EdsRecID: 0         
      },
      
      name: 'EDSCriteria',
      data: function () {        
        return {
          otherCriteria: false,
          isOpenEnded:false,
          ExpChangeAllow: false,
          saveIcon:'fas fa-plus',
          saveBtnName:'Submit',
          CommentsAllow:'N',
          succeeded:'',
          Diagnosis:'',
          criteria: '',
          dosageid: '',
          id: '',
          status: '',
          Minage: '',
          Maxage: '',
          //Unit: '',
          Length: '',
          MaxEDSUnit: '',
          MaxEDSLength: '',                
          //AllowMaxExpiryDateEdit: '',
          AllowComments: '',
          CreatedBy: '',
          CreatedDateTime: '',
          LastModifiedDateTime: '',
          LastModifiedBy: '',
          AttachValues: [
          { label: "Active", value: "A" },
          { label: "Inactive", value: "I" },
        
          ],
          CommentsValues: [
            { label: "Optional", value: "O" },
            { label: "Required", value: "R" },
            { label: "Not Allowed", value: "N" },            
          ],
          Unit : '',
          bkdays : '',
          backdatingunits: [
                    { id: "M", text: "Months" },
                    { id: "D", text: "Days" },
                    { id: "Y", text: "Years" }
                  ],
            IsBackDating: false,
            GenLetterAllow: false,
            PrescName:'',
            Comments:'',
            SAILPlansSelected : null,
              DisbleProvider:false,
              MsgPopup :'',
              showError: false,
              showModal:false,
              TypeHeadinptClass:'form-control form-control-xs',
              boxTwo: '',
              BtnSubmitdisabled:0,
              primaryText:'',
              PaidByThirdPArty:false,
              browseText:'Click Here',
              AppServiceID:0,                
              MaxMatch:20,
              AppName:'',
              title:"",
              subtitle: "Welcome", 
              HSN:'',
              fromDate: '',
              toDate: '',
              serviceDate: '',
              DateFormat:'',
              datapickClass:"form-control form-control-xs my-0",
              showInfo : false,
              PopUpVar:PopUpVariant,
              showDetailModal: false,
              showMessageModal: false,
              searched:false, 
              Msg: '',  
              Services:'',
              isAssessor:false ,
              TblData: [],
    // columns: ['delete','diagnosis','criteria', 'maxedunit','maxedslength','minage','maxage','generateletter',
    // 'commentallow','createdby','modifyby'],
    columns: ['delete','diagnosis','criteria', 'maxedunit','maxedslength','minage','maxage','generateletter',
              'commentallow','allowexpedit','openexpdate','createdby','modifyby'],
    options: {
      texts:{
        //count:"Showing {from} to {to} of {count} records|{count} records|One record",
        first:'First',
        last:'Last',
        //limit:"Records:",
        //page:"Page:",
        noResults:"No Criteria Record Found",
        //filterBy:"Filter by {column}",
        loading:'Loading...',
        defaultOption:'Select {column}',
        columns:'Columns'
      },
      headings: { 
        id:"Select Criteria",
        //status: "Status",
        diagnosis: "Diagnosis",
        criteria: "Criteria",
        maxedunit: "Max Unit",
        maxedslength: "Max Length",
        minage:"Min Age",
        maxage:"Max Age",
        generateletter:"Generate Letter",
        commentallow:"Comment Allow",
        allowexpedit: "Expiry Date Editable",
        openexpdate: "Open Expiry Date",
        createdby: "Created By",
        modifyby: "Modify By"
      },

      responseAdapter({data}) {
        return {
          data: formatData,
          count: data.length
        };
      },
      summary: false,
      caption: false,
      perPage:5,
      perPageValues:[5],
      dateColumns:['effectivedate','expirydate'],
      footerHeadings: false,
      filterable: false,
      filterable : '',
      // listColumns: {
      //   claimtype: [
      //     {id: "CL",
      //     text: "Claim"},
      //     {id: "PA",
      //     text: "Prior Approval"}
      //   ]
      // },

      templates: { 
        status(h, row) {
            if(row.status ==true)
            return "Active"
        else
        return  "Inactive"
        },
        commentallow(h, row) {
            if(row.commentallow == 'N')
            return "Not Allowed"
        else if(row.commentallow == 'R') // Optional
        return  "Required"
        else if(row.commentallow == 'O') // Optional
        return  "Optional"
        },  

        maxedunit(h, row) {
        if(row.diagnosis == 'Other')
        return ""
        else  if(row.maxedunit == 'D')
        return "Days"
        else if(row.maxedunit == 'M') // Optional
        return  "Month"
        else if(row.maxedunit == 'Y') // Optional
        return  "Year"
        }, // maxedunit

        maxedslength(h, row) {
        if(row.diagnosis == 'Other')
          return ""
        else
          return row.maxedslength
        },

        minage(h, row){
        if(row.diagnosis == 'Other')
          return ""
        else  
          return row.minage
        },

        maxage(h, row){
        if(row.diagnosis == 'Other')
          return ""
        else
          return row.maxage
        },

        generateletter(h, row) {
            if(row.generateletter ==true)
              return "YES"
            else
              return  "NO"
        },
        allowexpedit(h, row) {
            if(row.allowexpedit ==true)
            return "YES"
        else
        return  "NO"
        },
        openexpdate(h, row) {
            if(row.openexpdate ==true)
            return "YES"
        else
        return  "NO"
        },
        effectivedate(h, row) {
          return moment(row.effectivedate,"YYYY-MM-DD").format('YYYY/MM/DD');
        },
        expirydate(h, row) {
          return moment(row.expirydate,"YYYY-MM-DD").format('YYYY/MM/DD');
        },
    
      },


     pagination: {
            edge: true,
            nav: 'scroll',
            chunk: 5
          },
          //sortable: ['diagnosis','criteria', 'maxedunit','maxedslength','minage','maxage','generateletter','commentallow','createdby','modifyby'],
          //filterable: ['diagnosis','criteria', 'maxedunit','maxedslength','minage','maxage','generateletter','commentallow','createdby','modifyby'],
          
          filterable:'',
          sortIcon: {
                  base : 'fas',
                  is: 'fa-sort',
                  up: 'fa-sort-up',
                  down: 'fa-sort-down'
                  },
    },              
          }
        },
    
        components: { 
                Card,
                CardBody,
                TileNote ,
                Datepicker,
                PatientHistoryDetail,
                Subtitle
        },
    
        validations(){
          return {
            status:{
                    required: requiredIf(function () {
                return (this.otherCriteria == false)
            }),
            },
            Diagnosis:{
              required: requiredIf(function () {
                return (this.otherCriteria == false)}),
              maxLength:   maxLength(65),
            },
            criteria:{
              required: requiredIf(function () {
                return (this.otherCriteria == false)}),
              maxLength:  maxLength(2500),
            },       
            Minage:{
              required: requiredIf(function () {
                return (this.otherCriteria == false)}),
              numeric,
                    //maxLength: maxLength(2),
            },
            Maxage:{
              required: requiredIf(function () {
                return (this.otherCriteria == false)}),
              numeric,
            },
            Unit:{
                      required: requiredIf(function(form){
                          //return this.ExpChangeAllow == false
                      if((this.otherCriteria == false) && (this.isOpenEnded == false))
                          return true
                        }),
            },
            Length:{
                      required: requiredIf(function(form){
                          //return this.ExpChangeAllow == false
                      if((this.otherCriteria == false) && (this.isOpenEnded == false))
                          return true
                        }),
                      numeric,
                    //maxLength: maxLength(2),
            },
            CommentsAllow:{
              required: requiredIf(function () {
                return (this.otherCriteria == false)}),
            }
          }
        },
    
        filters: {
          moment: function (date) {
            return moment(date,"YYYY-MM-DD").format('YYYY/MM/DD');
          },
          stringify(value) {
            return JSON.stringify(value, null, 2)
          }  
        }, 
        

      created: function() {   
        
          //this.mode = this.mode;
          //if(this.mode  == "Edit")

          
            // if(this.mode == 'Edit')
            // {
            //   if(this.TblData.id !=undefined || this.TblData.id !=null)
            //   {   
            //     this.saveBtnName = 'Edit Dosage';
            //     this.saveIcon = 'far fa-edit'; 
            //     //console.log('Created Mode: ' + this.mode);
            //     //console.log('id: ' + this.TblData.id);          
            //   }
            // this.id = this.TblData.id;
            // this.status = this.TblData.status == true  ? "A" : "I"; 
            // this.Diagnosis = this.TblData.diagnosis;
            // this.criteria = this.TblData.criteria;
            // this.Minage = this.TblData.minage;
            // this.Maxage = this.TblData.maxage;
            // this.Unit= this.TblData.maxedunit;
            // this.Length = this.TblData.maxedslength;
            // this.GenLetterAllow = this.TblData.generateletter;
            // this.CommentsAllow = this.TblData.commentallow; 
            // this.ExpChangeAllow = this.TblData.expchangeallow;
            // }
            // if(this.otherCriteria == true)
            // {
            //   this.status = "A";
            //   this.Diagnosis = "Other";
            //   this.criteria = "Patient does not meet at least one of the above criteria";
            //   this.Minage = 0;
            //   this.Maxage = 100;
            //   this.Unit= "Y";
            //   this.Length = 100;
            //   this.GenLetterAllow = false;
            //   this.CommentsAllow = "N"; 
            //   this.OpenExpiryDate = false;
            //   this.ExpChangeAllow = false;
            //   this.otherCriteria = true;
            //   this.isOpenEnded = false;
            // } 
            
            
          
      },
    watch:{
      // ExpChangeAllow:function(){
      //     if(this.ExpChangeAllow == false)
      //     {
      //       this.Unit ='';
      //       this.Length =0;
             
      //     }
      // },
    },
      methods: {
        showMsgBox(msg,data,MethodNo,done) {
           var vm  = this;
          this.boxTwo = ''
          this.$bvModal.msgBoxConfirm(msg, {
          title: 'Please Confirm',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          cancelVariant: 'default',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true, 
        })
          .then(value => {
            this.boxTwo = value
            ////console.log(value)
            if(value)
            {
              if(MethodNo ==2)
               {
                 done()
                 //vm.DelConfirm = this.boxTwo;
               }
               if(MethodNo ==1)
                this.deleteCriteria(data);
            }
          })
          .catch(err => {
            // An error occurred
          })
      },

        deleteCriteria(rowdata)
        {
          //console.log('row data' + rowdata.criteriaid)
              var vm = this;
              vm.searched = false;
              var params = new URLSearchParams();
              //params.append('usergroupid', this.tblRow.id);
              params.append('id', rowdata.criteriaid);
              axios.delete("SaskHealthApi/Codes/DeleteCriteria", {headers: { Authorization: "Bearer " + localStorage.access_token },params,})
              .then(function (response) {
                if(response.data ==true)
                {
                  vm.showMsg('Criteria successfully deleted' , '', 'Eds Criteria message')
                  vm.loadTable();
                }
                else
                vm.showMsg('Criteria was not deleted, please contact system administrator' , '', 'Eds Criteria message')
              })
              .catch(function (er) {
                        //console.log(er)
                    }).then(function () {

                    }); 
        },
        loadTable()
    {

    var vm = this;
    vm.searched = false;
    var params = new URLSearchParams();
     //params.append('usergroupid', this.tblRow.id);
     params.append('usergroupid', this.EdsRecID);
     axios.get("SaskHealthApi/Codes/GetEDSCriteria", {headers: { Authorization: "Bearer " + localStorage.access_token },params,})
    .then(function (response) {
         vm.TblData=response.data;
         //console.log(vm.TblData);

      })
      .catch(function (er) {
                    //console.log(er)
                }).then(function () {

                }); 
    },
        AddCriteria(){
          var vm = this;
            if(this.otherCriteria == true)
              {
                console.log("Inside otherCriteria");
                vm.status = "A";
                vm.Diagnosis = "Other";
                vm.criteria = "Patient does not meet any one of the listed criteria above";
                //vm.criteria = "Patient does not meet at least one of the above criteria";
                vm.Minage = 0;
                vm.Maxage = 100;
                vm.Unit= "Y";
                vm.Length = 100;
                vm.GenLetterAllow = false;
                vm.CommentsAllow = "N"; 
                vm.OpenExpiryDate = false;
                vm.ExpChangeAllow = false;
                vm.otherCriteria = true;
                vm.isOpenEnded = false;
              } 
              else if(this.isOpenEnded == true)
              {
                vm.Unit= "Y";
                vm.Length = 999;
              }
            var url = "SaskHealthApi/Codes/PostAddEDSCriteria/"
            var params = {
                "_": Date.now(), 
                //"ID": vm.id,
                "UserEdsID"  : vm.EdsRecID,
                "Status": vm.status,  
                "Diagnosis": vm.Diagnosis,
                "Criteria": vm.criteria,
                "Minage": vm.Minage,
                "Maxage": vm.Maxage,
                "MaxEDSUnit": vm.Unit,
                "MaxEDSLength": vm.Length,                
                "AllowMaxExpiryDateEdit": vm.ExpChangeAllow,
                "OpenExpiryDate": vm.isOpenEnded,
                "IsItOtherCriteria": vm.otherCriteria,
                "GenLetter": vm.GenLetterAllow,
                "AllowComments": vm.CommentsAllow,
                "CreatedDateTime": vm.CreatedDateTime,
                "CreatedBy": vm.CreatedBy,
                "LastModifiedDateTime": vm.LastModifiedDateTime,
                "LastModifiedBy": vm.LastModifiedBy
                      
                }                 
           axios({
              method: 'post',
              url: url,
              headers: { 'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken },
              data: params
            }).then(function (response) {
                  console.log(response);
                  if(response.data.succeeded == true)
                  {
                    vm.loadTable();
                    vm.showMsg('EDS Criteria Successfully Saved','','Eds Criteria message')
                    vm.ClearData();   
                  }     
                  else
                    vm.showMsg(response.data.errors + "!" + " Please contact system administrator" , '', 'Eds Criteria message')
                  })
                .catch(function (er) {
                  if(er.status ==400)
                  {
                    vm.showModal = true; 
                    vm.succeeded = false;
                    vm.Msg="Warning: EDS Dosage Criteria Not Successfully Updated For " +  vm.criteria +" ( " + er.data.message + ").";  
                  }
                  else if(er.status == 500)
                  {
                    vm.showModal = true;                          
                    if(er.data.message !=null)
                    vm.Msg = er.data.message;
                    else
                    vm.Msg = "Network Related Error ! Please contact system administrator." 
                  }  
                })
                .then(function () {
                }); 
        },
        ClearData()
        {
        
            this.Minage = '';
            this.Maxage = '';
            this.criteria = ''
            this.Diagnosis = ''
            this.Unit = ''
            this.Length = ''
            this.GenLetterAllow = false
            this.ExpChangeAllow = false
            this.isOpenEnded = false
            this.otherCriteria = false
            //this.status=''
            //this.CommentsAllow = ''
             
        },
        EditCriteria(){
        var vm = this; 
          var url = "SaskHealthApi/Codes/PostEditEDSCriteria/"
          var params = {
              "_": Date.now(), 
              "ID": vm.id,
              "Status": vm.status,  
              "Diagnosis": vm.Diagnosis,
              "Criteria": vm.criteria,
              "Minage": vm.Minage,
              "Maxage": vm.Maxage,
              "MaxEDSUnit": vm.Unit,
              "MaxEDSLength": vm.Length,                
              "AllowMaxExpiryDateEdit": vm.ExpChangeAllow,
              "OpenExpiryDate": vm.isOpenEnded,
              "GenLetter": vm.GenLetterAllow,
              "AllowComments": vm.CommentsAllow,
              "CreatedDateTime": vm.CreatedDateTime,
              "CreatedBy": vm.CreatedBy,
              "LastModifiedDateTime": vm.LastModifiedDateTime,
              "LastModifiedBy": vm.LastModifiedBy
                    
              }                 
          axios({
            method: 'post',
            url: url,
            headers: { 'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken },
            data: params
          }).then(function (response) {
                ////console.log(response);
                  vm.succeeded = true;
                  vm.Msg="Dosage Criteria Successfully Updated For " +  vm.criteria +".";   
                  vm.showModal=true;          
              })
              .catch(function (er) {
                if(er.status ==400)
                {
                  vm.showModal = true; 
                  vm.succeeded = false;
                  vm.Msg="Warning: Dosage Criteria Not Successfully Updated For " +  vm.criteria +" ( " + er.data.message + ").";  
                }
                else if(er.status == 500)
                {
                  vm.showModal = true;                          
                  if(er.data.message !=null)
                  vm.Msg = er.data.message;
                  else
                  vm.Msg = "Network Related Error ! Please contact system administrator." 
                }  
              })
              .then(function () {
              }); 
        },

        ClosePopup: function() {
           
            this.$emit('criteriadone');
        },
        SavePopup: function(){
          //console.log(this.$v.$error)
           this.$v.$touch();
           if (!this.$v.$invalid){

            ////console.log('SavePopup mode : ' + this.mode);
            //this.AddCriteria();
              //if(this.mode = 'Edit')    
              if(this.TblData.id == undefined)
              {
                ////console.log('Add Called');
                this.AddCriteria();
              } 
              else
              {
                ////console.log('Edit Called');
                this.EditCriteria(); 
              }
              //if(this.id != undefined)     
              // if(this.mode = 'Edit')
              // {
              //   //console.log('Edit Called');
              //   this.EditCriteria();               
              // }
              this.ClearData();
         }
        },
        DosageCriteriaExit: function(){
            this.showModal=false;
            if(this.succeeded)
            {
              this.$root.$emit('bv::hide::modal', 'editModal', '#btnShow');   
              this.$emit('dosageUpdated');
              // this.$v.$reset(); 
            }
            else
            {
               this.showModal=false;
            }
        },

        UserTypeChange(){},
        radiochange(value){
          //console.log('radio value ' + value)
        },
        Go(){
            this.$router.push('/DPEBB/MainHome')
        },
        ClosePopup1(){
          this.showError =false;
        },
        Show(){
              this.showInfo =true;
        }, 
    
 
    
        showMsg(msg,data,Title) {
              this.boxTwo = ''
              this.$bvModal.msgBoxOk(msg, {
              title: Title,
              size: 'md',
              buttonSize: 'md',
              okVariant: 'danger',          
              okTitle: 'Close', 
              footerClass: 'p-2',
              hideHeaderClose: true,
              hideHeaderCancel: true,
              centered: true, 
            })
              .then(value => {
                
    
                this.boxTwo = this.msg;
                if(value)
                {
                 
                }
              })
              .catch(err => {
                // An error occurred
              })
          },
 
 
        ValidatetoDate(){

          if((this.toDate == '' || this.toDate ==null) && (this.fromDate != '' && this.fromDate != null))
            {
              return false;
            }
            else if((this.toDate != '' || this.toDate !=null) && (this.fromDate != '' && this.fromDate != null))
            {
              if(moment(this.fromDate).toISOString() <= moment(this.toDate).toISOString())
              {
                  return true;
              }  
              else
              return false;
            }
            else if((this.toDate != '' || this.toDate !=null) && (this.fromDate == '' || this.fromDate == null))
            {
                return true;
            }
            else
            {
            return false;
            }
    
          },
 
 
        CloseDetailModal() {
          this.showDetailModal = false;
        },
    
        PopMsgClose() {
    
        },
    
        OnResize(event){
    
        },
     
      },
    
      computed:{
          UserName(){
              return !this.$store.getters.GetCurrentUser ? false : this.$store.getters.GetCurrentUser;
          },
          AllAppLevel(){
              return this.$store.getters.GetAllApplevel;
            } 
      },  
      
    
      beforeCreate: function() {  
      
      },
    
      mounted: function () {

      },
    }
     
    
    </script>
    
    <style scopped>
    custom-control-label {
      position: relative;
      margin-bottom: 0;
  }
   
  label {
      display: inline-block;
      margin-bottom: .5rem;
  }
     .row.no-gutter [class*='col-']   {
       padding-right:1px;
       
     }
     .list-group-item {
        position: relative;
        display: block;
        padding: 0px 15px;
        margin-bottom: -1px;
        border: 1px solid #ddd;
        background-color: blue;
        line-height: 1em
    }
    .col-lg-1>div {background-color:#ddd;}
    
    #docimg {
       
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50; 
    }
    #line {
      border-top:1px solid   rgba(7, 14, 109, 0.25);
    }
    
    
    .test-modal .modal {
        padding: 0 !important;
        padding-left: 0px !important;
        overflow-y: scroll;
    }
    
    .test-modal .modal-dialog { 
        max-width: 100%;
        height: 100%;
        margin: 0;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        z-index: 100000;
        padding-right: 0px !important;
        padding-left: 0px !important;
    }
    
    .modal-open {
        padding: 0 !important;
        padding-left: 0px !important;
        overflow-y: scroll;
    }
    
    #phModal {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    

    .thing {
  padding: .5rem;
  /* width: 420px; */
  box-shadow: 0 10px 20px 0 rgba(0,0,0,0.11),
    0 5px 10px 0 rgba(0,0,0,0.08);
  background-color: #ffffff;
  border-radius: 0.5rem;
  
  border-left: 0 solid #00ff99;
  transition: border-left 100ms ease-in-out, padding-left 100ms ease-in-out;
}

.thing:hover {
  padding-left: 0.5rem;
  border-left: 0.5rem solid #00ff99;
}

/* .thing > :first-child {
  margin-top: 0;
}

.thing > :last-child {
  margin-bottom: 0;
} */


    </style>